module.exports = __webpack_public_path__ + "img/canvasMenu6.419829c4.svg";